import React from 'react';
import { HiEye, HiTrash, HiPencil } from 'react-icons/hi';

const Mastercarder = ({ children, heading, subheading, editFunc, deleteFunc, viewFunc, diagnosis, setSelectedDiagnosis }) => {
  return (
    <div className='card shadow-sm p-3 mb-4 master-carder' style={{ borderRadius: "13px" }} >
      <div className='d-flex align-items-center justify-content-between'>
        <div onClick={editFunc}>
          <h6 className="card-title fw-bolder">{heading}</h6>
          <p className="card-subtitle mb-2 text-black-50">{subheading}</p>
        </div>
        <span className='d-flex gap-1'>
          {viewFunc && <div onClick={viewFunc} style={{border:"1px solid",cursor:'pointer'}} class=" border text-success border-success"><HiEye size={20} /></div>}
          {editFunc && <div onClick={editFunc} style={{border:"1px solid", cursor:'pointer'}} class="border-warning text-warning p-2 bg-opacity-75  rounded-1"><HiPencil size={20} /></div>}
          {deleteFunc && <div onClick={deleteFunc} style={{border:"1px solid", cursor:'pointer'}} class="border-danger text-danger p-2 bg-opacity-75  rounded-1"><HiTrash size={20} /></div>}
        </span>
      </div>
      {children}
    </div>
  );
};

export default Mastercarder;
